<template>
  <div class="select-date">
    <van-popup v-model="showPopup" position="bottom" @click-overlay="onCancel">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      ></van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.show,
      currentDate: new Date(),
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(2100, 11, 31)
    }
  },
  watch: {
    show(newVal) {
      this.showPopup = newVal
    }
  },
  methods: {
    onConfirm(event) {
      console.log('event', event)
      this.$emit('confirm', event)
    },
    onCancel() {
      this.$emit('close')
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      }
      if (type === 'month') {
        return `${value}月`
      }
      return `${value}日`
    }
  }
}
</script>

<style scoped lang="less">
.select-date {
  .content {
    height: 100%;
    box-sizing: border-box;
    .header {
      height: 108px;
      font-size: 34px;
      font-weight: 500;
      color: #1a1a1a;
      display: flex;
      align-items: center;
      padding: 30px 36px;
      box-sizing: border-box;
      .close {
        width: 44px;
        height: 44px;
        margin-left: auto;
      }
    }
    .select-result {
      height: 82px;
      padding: 20px 36px;
      display: flex;
      align-items: center;
      font-size: 32px;
      color: #000;
      box-sizing: border-box;
      border-bottom: 1px solid #f0f0f0;
      .result {
        display: flex;
        align-items: center;
        margin-right: 54px;
        color: #000;
        .dot {
          width: 10px;
          height: 10px;
          background: #ff3934;
          border-radius: 10px;
          margin-right: 12px;
        }
      }
      text {
        color: #ff3934;
      }
    }
    .list {
      padding: 30px 36px;
      height: calc(100% - 190px);
      box-sizing: border-box;
      .item {
        font-size: 30px;
        color: #333333;
        height: 96px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        &:active {
          background-color: #fafafa;
        }
      }
    }
  }
}
</style>
